export const GrowthPlanData = [
    "Total 5000 coversation",
    "1000 free chatbot conversation",
    "Generate, capture & track your potential leads",
    "Whatsapp Catalogue",
    "Whatsapp marketing through campaign",
    "One Customised bot flow",
    "Bulk product & customer upload",
    "Free 50 marketing templates",
    "Whatsapp business API & Integration",
]